import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';

import { Panel } from '../../Panel/Panel.jsx';
import { toggleMobileEnrouteMode } from '../../../actions/screen';
import { NavigationRoutesWrapperContent } from './NavigationRoutesWrapperContent/NavigationRoutesWrapperContent';

export const NavigationRoutesWrapper = memo(({ children }) => {
    const dispatch = useDispatch();
    const mobileEnrouteMode = useSelector((state) => get(state, 'screen.mobileEnrouteMode', false));
    const { t: translate } = useTranslation();
    const handleToggleMobileEnrouteMode = React.useCallback(() => dispatch(toggleMobileEnrouteMode()), []);

    return (
        <div className="enr">
            <Panel
                title={translate('navigationRoute.navRoutes')}
                className="enr__panel"
                toggle={{
                    label: translate('navigationRoute.fullMode'),
                    defaultToggled: !mobileEnrouteMode,
                    onToggle: handleToggleMobileEnrouteMode,
                    isControlled: true,
                }}
            >
                <NavigationRoutesWrapperContent />
                <table className="enr__table">{children}</table>
            </Panel>
        </div>
    );
});
